//  构造器type参数说明
let eq='eq'//•	等于 =
let ne='ne'//•	不等于 <>
let like='like'; //•	模糊查询 like %value%
let likeLeft='likeLeft'//•	左边模糊  %value
let likeRight='likeRight'//•	•	右边模糊  value%
let notLike='notLike'//•	•	不关联查not like %value%
let gt='gt'//•	•	大于 >
let lt='lt'//•	•	小于 <
let ge='ge'//•	•	大于等于 >=
let le='le'//•	•	小于等于 <=
let orderByAsc='orderByAsc'//•	•	根据column正序排序，不需要value
let orderByDesc='orderByDesc'//•	•	根据column倒序排序，不需要value

export default {
	eq,ne,like,likeLeft,likeRight,notLike,gt,ge,lt,le,orderByAsc,orderByDesc
} 
